import React from 'react';
import styles from './About.module.css';
import andy from '../../common/assets/images/AndresFrank-44-modified-01-restyled.png';
import cv from '../../common/assets/ANDRES_FRANK_RESUME.pdf';
import axios from 'axios';

const About = () => {

    async function handleDownloadClick() {
        try {
            await axios.post('/downloaded-cv');
        } catch(e) {
            console.log(e);
        }
    }

    return (
        <div className={styles.container}>
            <h2 className={styles.header}>03. About</h2>
            <div className={styles.bioContainer}>
                <div className={styles.photoBtnsContainer}>
                    <figure>
                        <img src={andy} alt="none" className={styles.photo}/>
                    </figure>
                    <div className={styles.actionContainer}>
                        <a 
                            onClick={handleDownloadClick}
                            className={styles.downloadCV} 
                            href={cv}
                            download="ANDRES_FRANK_RESUME"
                        >
                            Download CV
                        </a>
                        <a href="/#contact" className={styles.touch}>Get in Touch</a>
                    </div>
                </div>
                <div className={styles.bioText}>
                    <h2 className={styles.bio}>Born and raised in Buenos Aires.
                        <br/>
                        Music graduate, former law student.
                        <br />
                        Newly discovered passion for programming.
                    </h2>
                    <h3 className={styles.bio2}>
                        <p>
                            I'm a&nbsp;
                            <a 
                                 target="_blank"
                                 rel="noreferrer"
                                 href="https://www.youtube.com/watch?v=Xwfi10JETG0"
                                className={styles.musician}
                            >
                                musician
                            </a> 
                            &nbsp;turned web developer, looking for new experiences in the tech industry. 
                            I have been involved in the educational side of programming for over a year,
                            and I'm currently looking for a role as a developer in order to perfect my skills 
                            and enrich my background. 
                        </p>
                        <p>
                            Since I've been more in touch with the front-end spectrum recently, 
                            I feel more confident being involved in that area right now. However,
                            I also find the back-end and the mobile world as attractive and satisfying.
                        </p>
                        <p>Here are a few of the technologies I work with:</p>
                        <ul className={styles.skillsList}>
                            <div className={styles.sectionContainer}>
                                <div className={styles.listSection}>
                                    <li>Javascript</li>
                                    <li>HTML</li>
                                    <li>CSS</li>
                                    <li>SQL</li>
                                    <li>Java</li>
                                </div>
                                <div className={styles.listSection}>
                                    <li>Node JS</li>
                                    <li>React</li>
                                    <li>React Native</li>
                                    <li>Redux</li>
                                    <li>Spring</li>
                                </div>
                            </div>
                            <div className={styles.sectionContainer}>
                                <div className={styles.listSection}>
                                    <li>Express</li>
                                    <li>Sequelize</li>
                                    <li>PostgreSQL</li>
                                    <li>MySQL</li>
                                    <li>JPA</li>
                                </div>
                                <div className={styles.listSection}>
                                    <li>Firebase</li>
                                    <li>Passport</li>
                                    <li>Github</li>
                                    <li>REST API</li>
                                    <li>Scrum</li>
                                </div>
                            </div>
                        </ul>
                    </h3>
                </div>
            </div>
        </div>
    )
}

export default About;
